import { createAction } from 'redux-act'

export const setQuizConfig = createAction('set quiz config')

export const setQuestionsResponse = createAction('set user response on question')

export const nextQuestion = createAction('next question')

export const nextChoice = createAction('next choice')

export const setOutfitResult = createAction('set user quiz result')

export const setQuizSubmit = createAction('set user quiz submit')

export const setCompletedStepsInit = createAction('set 1 as steps for CompletedSteps')
